import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config';
import { SOCIAL_FRONTEND_URL } from '../../config';

import styles from './LandingPage.module.css'; // Assuming you add the new styles to your existing module
import modernhouseimage from '../../assets/images/modernhouse.jpeg';
import { FaHome, FaBriefcase, FaQuoteLeft, FaEnvelope } from 'react-icons/fa';
import { jwtDecode } from 'jwt-decode';
import Loader from '../../components/Loader';
import Swal from 'sweetalert2';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import imageLogo from "../../assets/images/LogoBuildStart03.png";
import imageLogoDark from "../../assets/images/BSPLogoDark.png";
import imageLogoGold from "../../assets/images/BSPLogoTranSmall.png";


import modernimage01 from '../../assets/images/resi01.jpeg';
import modernimage02 from '../../assets/images/resi02.jpeg';
import modernimage03 from '../../assets/images/resi03.jpeg';
import modernimage04 from '../../assets/images/resi04.jpeg';
import modernimage05 from '../../assets/images/resi05.jpeg';
import modernimage06 from '../../assets/images/resi06.jpeg';

// Array of images for the login page visual
const outcomeImages = [modernhouseimage, modernimage01, modernimage02, modernimage03, modernimage04, modernimage05, modernimage06];


// --- NEW: Forgot Password Page Component ---
export const ForgotPasswordPage = () => {
  // State to handle the post-submission confirmation view
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    // In a real app, you would make an API call here to your backend.
    // For now, we'll just switch to the confirmation view.
    setSubmitted(true);
  };

  const FormView = () => (
    <div className={styles.authForm}>
      <Link to="/" className={styles.authLogo}>Build Start</Link>
      <h1 className={styles.authTitle}>Forgot Password?</h1>
      <p className={styles.authSubtitle}>No problem. Enter your email and we'll send you a link to get back into your account.</p>
      
      <form onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label htmlFor="email">Email Address</label>
          <input 
            type="email" 
            id="email" 
            name="email" 
            className={styles.formInput} 
            placeholder="you@example.com" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button type="submit" className={styles.btnPrimaryAuth}>Send Reset Link</button>
      </form>
      
      <p className={styles.authRedirect}>
        <Link to="/login" className={styles.link}>← Back to Login</Link>
      </p>
    </div>
  );

  const ConfirmationView = () => (
     <div className={styles.authForm}>
      <div className={styles.confirmationContainer}>
        <FaEnvelope className={styles.confirmationIcon} />
        <h1 className={styles.authTitle}>Check your email</h1>
        <p className={styles.authSubtitle}>
          We've sent a password reset link to <strong>{email}</strong> if an account with that email exists.
        </p>
         <Link to="/login" className={`${styles.btnPrimaryAuth} ${styles.linkButton}`}>Back to Login</Link>
      </div>
    </div>
  );

  return (
    <div className={styles.authContainer}>
      <div className={styles.authVisual}>
        {/* Using a static, calming image is best for this page */}
        <img src={modernimage01} alt="Calm and modern kitchen" />
      </div>
      <div className={styles.authFormContainer}>
        {/* Show either the form or the confirmation message */}
        {submitted ? <ConfirmationView /> : <FormView />}
      </div>
    </div>
  );
};




// --- 1. Login Page Component ---
export const NewLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [serverError, setServerError] = useState('');
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  const { setToken } = useAuth();
  const effectRan = useRef(false);

  const handleGoogleLogin = () => {
    window.location.href = `${API_BASE_URL}/api/auth/google-login`;
  };

  const handleFacebookLogin = () => {
    window.location.href = `${API_BASE_URL}/api/auth/facebook-login`;
  };


   // --- CAPTCHA STATE ---
  const [turnstileToken, setTurnstileToken] = useState('');
  const turnstileRef = useRef(null);
  const widgetId = useRef(null);


  // State to hold the randomly selected image
  const [randomImage, setRandomImage] = useState(null);

  // useEffect hook to select an image when the component mounts
  useEffect(() => {
    // Pick a random index from the outcomeImages array
    const randomIndex = Math.floor(Math.random() * outcomeImages.length);
    setRandomImage(outcomeImages[randomIndex]);
  }, []); // The empty array [] ensures this effect runs only once



// --- LOAD TURNSTILE ---
  useEffect(() => {
    // Check if user is admin shortcut, maybe skip loading? 
    // We load it anyway for standard users.
    const scriptId = 'cloudflare-turnstile-script';
    let script = document.getElementById(scriptId);

    if (!script) {
        script = document.createElement('script');
        script.id = scriptId;
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
        script.async = true;
        document.body.appendChild(script);
    }

    const interval = setInterval(() => {
        if (window.turnstile && turnstileRef.current) {
            clearInterval(interval);
            if (widgetId.current) window.turnstile.remove(widgetId.current);

            try {
                widgetId.current = window.turnstile.render(turnstileRef.current, {
                    sitekey: '0x4AAAAAACLyRZf_NiiPXSqz', // <---  SITE KEY HERE
                    callback: (token) => setTurnstileToken(token),
                    'expired-callback': () => setTurnstileToken(''),
                    'error-callback': () => setTurnstileToken(''),
                });
            } catch (e) {
                console.error("Turnstile render error:", e);
            }
        }
    }, 100);

    return () => clearInterval(interval);
  }, []);
  // ------------------------------------



  const validateLogin = () => {
    // Allow special admin username shortcut without email format validation
    if ((email || '').toLowerCase() === 'administrator') {
      setErrors({});
      return true;
    }

    const errors = {};
    if (!email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = 'Email address is invalid';
    }

    if (!password) {
      errors.password = 'Password is required';
    }



    // --- CAPTCHA CHECK ---
    if (!turnstileToken) {
       setServerError('Please complete the "Verify Human" check.');
       return false; 
    }



    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email")
      setEmail(value);
    else if (name === "password")
      setPassword(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? '' : prevErrors[name],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateLogin()) {
      return;
    }
    setLoading(true);
    setServerError('');

    // Special admin shortcut: immediate redirect and session bootstrap
    if ((email || '').toLowerCase() === 'administrator') {
      const adminToken = 'admin-local';
      localStorage.setItem('token', adminToken);
      setToken(adminToken);
      localStorage.setItem('isAdmin', 'true');
      localStorage.setItem('userType', 'Admin');
      localStorage.setItem('loggedInUsername', 'administrator');
      navigate('/admin');
      setLoading(false);
      return;
    }

    try {
      // Step 1: Check user type
      const userTypeResponse = await axios.post(`${API_BASE_URL}/api/auth/check-user-type`, { email });
      const { userType } = userTypeResponse.data;

      // Step 2: Proceed with login based on user type
      let loginUrl = '';
      if (userType === 'Home') {
        loginUrl = `${API_BASE_URL}/api/HomeUsers/login`;
      } else if (userType === 'Business') {
        loginUrl = `${API_BASE_URL}/api/BusinessUser/loginBusinessUser`;
      } else {
        toast.error("User not found.");
        setLoading(false);
        return;
      }



      // --- ADD CAPTCHA TOKEN TO PAYLOAD ---
      const payload = { 
        email, 
        password, 
        rememberMe,
        captchaToken: turnstileToken 
      };



      const loginResponse = await axios.post(loginUrl, payload);
      const result = loginResponse.data;

      console.log(`loginResponse.data = ${loginResponse.data}`);

      if (result.model.token) {

        console.log(`Token found = ${result.model.token}`);

        if (result.model.developerBusinessName) {
          localStorage.setItem('developerBusinessName', result.model.developerBusinessName);
        }

        localStorage.setItem('token', result.model.token);
        setToken(result.model.token);

        console.log(`Token SET`);

        // Set this cookie so the Social app can read it.
        // IMPORTANT:
        // - In production on *.buildstart.au, we want Domain=.buildstart.au.
        // - In local dev on *.local.buildstart.au, we want Domain=.local.buildstart.au.
        //   Using the wrong domain means the browser will silently ignore the cookie.
        const hostname = window.location.hostname;
        const isLocalSubdomain = hostname.endsWith('.local.buildstart.au');
        const cookieDomain = isLocalSubdomain ? '.local.buildstart.au' : '.buildstart.au';

        Cookies.set('token', result.model.token, {
          expires: 7,
          path: '/',
          domain: cookieDomain,
          secure: window.location.protocol === 'https:',
          sameSite: 'Lax'
        });


        console.log(`COOKIE SET`);

         console.log(`CHECKING USERTYPE = ${userType}`);


        // SET COOKIE AND STORAGE DATA
        if (userType === 'Home') {
          sessionStorage.setItem('userImage', result.model.profilePic);
          sessionStorage.setItem('loginSuccessMessage', result.message.join(' '));
          sessionStorage.setItem('loggedInHomeUserId', result.model.homeUserId);
          sessionStorage.setItem('userType', 'Home');
          localStorage.setItem('loggedInHomeUserId', result.model.homeUserId);
          localStorage.setItem('userType', 'Home');
          localStorage.setItem('loggedInUsername', result.model.email);


        } else if (userType === 'Business') {
          localStorage.setItem('businessName', result.model.businessName);
          localStorage.setItem('businessId', result.model.businessId);
          localStorage.setItem('loggedInBusinessUserId', result.model.businessUserId);
          localStorage.setItem('loggedInBusinessId', result.model.businessId);
          localStorage.setItem('userType', 'Business');
          localStorage.setItem('loggedInUsername', result.model.email);

          console.log(result.model.email);

          sessionStorage.setItem('userImage', result.model.profilePic);
          sessionStorage.setItem('loginSuccessMessage', result.message.join(' '));
          sessionStorage.setItem('showBusinessToast', true);
          localStorage.setItem('shouldOnboard', result.model.isOnboarding);


          
        }

         console.log(`SESSION SET`);


        // REDIRECT
        // Determine if we perform standard login or we redirect to social page:
        // ADMIN REDIRECT: If the login email denotes administrator, forward to Admin Dashboard
        const loginEmail = ((result?.model?.email) || email || '').toLowerCase();
        if (loginEmail === 'administrator' || loginEmail.startsWith('administrator@')) {
          localStorage.setItem('isAdmin', 'true');
          localStorage.setItem('userType', 'Admin');
          navigate('/admin');
          return;
        }

         const redirectUri = searchParams.get('redirect_uri');
         console.log(`CHECKING REDIRECT PARAM ${redirectUri}`);

        if (redirectUri) {
          // Only if it exists, proceed to check its contents.
          // Note the use of .includes() instead of .contains()
          if (redirectUri.startsWith('https://social.buildstart.au') || redirectUri.includes('social.local.buildstart.au')) {
            console.log(`Valid redirect URI found. Redirecting to: ${redirectUri}`);
            // Use a hard redirect for cross-domain navigation.
            window.location.href = redirectUri;
            return;
          }
        }

        // --- NEW: Check for returnUrl (Deep Link) ---
        const returnUrl = searchParams.get('returnUrl');
        if (returnUrl) {
            console.log(`Return URL found: ${returnUrl}`);
            navigate(decodeURIComponent(returnUrl));
            return;
        }

        // If redirectUri is null OR it's not a valid URL, the code will continue to here.
        console.log(`READY TO ENTER BUILDSTART SITE `);

        // Else do standard login here

        if (userType === 'Business') { 

          navigate('/businessdash');
        
        } else if (userType === 'Home') {

          if (result.model.isOnboarding) {
            navigate(`/home-user-onboarding-new?userId=${result.model.homeUserId}`);
          } else {
            navigate('/newhome');
          }

        }
        

      } else {

        setServerError(result.message.join(' '));

        // --- RESET CAPTCHA ---
        if (window.turnstile && widgetId.current) {
            window.turnstile.reset(widgetId.current);
            setTurnstileToken('');
        }



      }
    } catch (error) {
        
        const errorMessage = error.response?.data?.message || ['An error occurred. Please try again.'];
        setServerError(Array.isArray(errorMessage) ? errorMessage.join(' ') : errorMessage);

      // --- RESET CAPTCHA ON ERROR ---
      if (window.turnstile && widgetId.current) {
          window.turnstile.reset(widgetId.current);
          setTurnstileToken('');
      }



    } finally {
      setLoading(false);
    }
  };



useEffect(() => {
    // Using a ref to prevent double-execution in React 18 Strict Mode is good practice
    if (effectRan.current) return;
    effectRan.current = true;

    const activationCode = searchParams.get('code');
    const emailParam = searchParams.get('email');

    if (activationCode && emailParam) {
      setLoading(true);

      // Call the NEW, SINGLE endpoint
      axios.post(`${API_BASE_URL}/api/auth/activate-account`, { activationCode, email: emailParam })
        .then(response => {
          setLoading(false);

          console.log(response);

          // The new backend response has a simple 'message' property
          const successMessage = response.data?.message || 'Your account is now active.';
          
          Swal.fire({
            icon: 'success',
            title: 'Account Activated!',
            text: successMessage,
            confirmButtonText: 'Proceed to Login'
          }).then(() => {
            navigate('/login'); // Redirect to login page after success
          });
        })
        .catch(error => {
          setLoading(false);
          let friendlyErrorMessage = 'An unknown error occurred. Please try again.';

          if (error.response && error.response.data?.message) {
            // Get the specific error message from our new backend response
            friendlyErrorMessage = error.response.data.message;
          }
          
          Swal.fire({
              icon: 'error',
              title: 'Activation Failed',
              text: friendlyErrorMessage,
          });
        });
    }
  }, [searchParams, navigate]);


  return (
    <div className={styles.authContainer}>
      <ToastContainer />
      {loading && <Loader />}
      <div className={styles.authVisual}>
        {randomImage && <img src={randomImage} alt="Beautifully completed home project" />}
      </div>
      <div className={styles.authFormContainer}>
        <div className={styles.authForm}>

          <a href="/" className={styles.authLogo}>
                    <img
            src={imageLogoGold}   // Replace with your logo image path
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}  // Adjust size & spacing as needed
          />
          
          </a>
          <h1 className={styles.authTitle}>Welcome Back</h1>
          <p className={styles.authSubtitle}>Log in to access your projects and teams.</p>
          
          
          <div className={styles.authDivider}>
            <span>&nbsp;</span>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" className={styles.formInput} placeholder="you@example.com" value={email} onChange={handleChange} />
              {errors.email && <p className="error-message" style={{color: 'red'}}>{errors.email}</p>}
            </div>
            <div className={styles.formGroup}>
                <div className={styles.labelRow}>
                    <label htmlFor="password">Password</label>
                    <Link to="/reset-password" className={styles.link}>Forgot?</Link>
                </div>
              <input type="password" id="password" name="password" className={styles.formInput} placeholder="••••••••" value={password} onChange={handleChange} />
              {errors.password && <p className="error-message" style={{color: 'red'}}>{errors.password}</p>}
            </div>


            {/* --- TURNSTILE WIDGET CONTAINER --- */}
            <div className={styles.formGroup} style={{marginTop: '20px', display: 'flex', justifyContent: 'center'}}>
                {/* The widget will appear inside this DIV */}
                <div ref={turnstileRef}></div>
            </div>



            {serverError && (
              <div className={styles.serverErrorContainer}>
                <p className={styles.errorText}>{serverError}</p>
              </div>
            )}

            {/* <div className={styles.socialLoginContainer}>

              <div className={styles.socialDivider}>
                <span>OR</span>
              </div>

              <div className={styles.socialButtonsRow}>
                <button
                  type="button"
                  className={`${styles.socialButton} ${styles.googleButton}`}
                  onClick={handleGoogleLogin}
                >
                  <img
                    src="https://www.svgrepo.com/show/475656/google-color.svg"
                    alt="Google"
                    className={styles.socialIcon}
                  />
                  Continue with Google
                </button>

                <button
                  type="button"
                  className={`${styles.socialButton} ${styles.facebookButton}`}
                  onClick={handleFacebookLogin}
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
                    alt="Facebook"
                    className={styles.socialIcon}
                  />
                  Continue with Facebook
                </button>
              </div>

            </div> */}
            
            <button type="submit" className={styles.btnPrimaryAuth}>Log In</button>
          </form>
          
          <p className={styles.authRedirect}>
            Don't have an account? <a href="/select-role" className={styles.link}>Sign Up</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewLogin;
